import { render, staticRenderFns } from "./GbsHelpActivities.vue?vue&type=template&id=a45d213c"
import script from "./GbsHelpActivities.vue?vue&type=script&lang=ts"
export * from "./GbsHelpActivities.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports